import * as React from 'react';
import { Jumbotron } from 'reactstrap';
import { compose, setDisplayName, toClass } from 'recompose';
import andrewPic from './andrew.jpg';
import PrivacyInfo from './PrivacyInfo';
import TechnlogyInfo from './TechnologyInfo';

const enhance = compose(
    toClass,
    setDisplayName('AboutScene')
);

export default enhance(() => (
    <>
        <Jumbotron>
            <div className="image-cropper">
                <img src={andrewPic} alt="Picture of Andrew Bain" />
            </div>
            <h1>About show me the running</h1>
            <p className="lead">
                Show me the running is a hobby project by Andrew Bain. I like
                running!
            </p>
        </Jumbotron>
        <PrivacyInfo />
        <TechnlogyInfo />
    </>
));



// WEBPACK FOOTER //
// ./src/client/components/About/index.tsx